module.exports = __webpack_public_path__ + "static/img/icon_class_ear.152ff2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_ear.png
// module id = QTJY
// module chunks = 1